"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogPromiseHandler = exports.dialogContentHandler = void 0;
exports.ContentDialog = ContentDialog;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var content_dialog_1 = require("../../features/thunks/content-dialog");
var hooks_1 = require("../../store/hooks");
var dialogContentHandler = {
    body: (0, jsx_runtime_1.jsx)("div", { children: "Default Content Handler" }),
};
exports.dialogContentHandler = dialogContentHandler;
var dialogPromiseHandler = {
    resolve: null,
};
exports.dialogPromiseHandler = dialogPromiseHandler;
function ContentDialog() {
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.contentDialog; }), isOpen = _a.isOpen, header = _a.header, contentMaxWidth = _a.contentMaxWidth, hideCloseButton = _a.hideCloseButton, isDismissable = _a.isDismissable;
    var dispatch = (0, hooks_1.useAppDispatch)();
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, disableAnimation: true, isDismissable: isDismissable, onOpenChange: function (isOpen) {
            var _a;
            if (!isOpen) {
                dispatch((0, content_dialog_1.closeContentDialogThunk)());
                (_a = dialogPromiseHandler["resolve"]) === null || _a === void 0 ? void 0 : _a.call(dialogPromiseHandler, "cancel");
            }
        }, closeButton: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:close-circle-bold", className: "text-danger", fontSize: 26 }) }), hideCloseButton: hideCloseButton, classNames: {
            wrapper: "p-4 z-[60]",
            backdrop: "z-[59]",
            base: "mx-auto max-w-[calc(100vw-2rem)]",
        }, scrollBehavior: "inside", placement: "center", children: (0, jsx_runtime_1.jsxs)(react_1.ModalContent, { className: "".concat(contentMaxWidth || "max-w-3xl"), children: [header && (0, jsx_runtime_1.jsx)(react_1.ModalHeader, { className: "flex flex-col gap-1 pt-3 pb-2 px-4 border-b border-gray-100", children: header }), (0, jsx_runtime_1.jsx)(react_1.ModalBody, { className: "p-0", children: dialogContentHandler["body"] })] }) }));
}
